import { useState } from "react";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { candidateRequests } from "api/candidateApi";
import dataProvider from "server/dataProvider";
import LoadingActionButton from "server/components/LoadingActionButton";
import { useNotifyError } from "utils/useNotifyError";
import GoogleUsersDialog from "./GoogleUsersDialog";

// Reads back the accounts already generated for the campaign.
const GoogleUsersListButton = ({ campaignId }) => {
  const notifyError = useNotifyError();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(null);

  const handleOpen = async () => {
    setLoading(true);
    try {
      const { data } = await dataProvider.customRequest(candidateRequests.campaignGoogleUsers(campaignId), null, "GET");
      setRows(data ?? []);
    } catch (error) {
      notifyError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <LoadingActionButton
        label="Виж Google акаунти"
        icon={<ListAltIcon fontSize="small" />}
        loading={loading}
        onClick={handleOpen}
        width={200}
        height="auto"
        minWidth={200}
      />

      <GoogleUsersDialog
        open={Boolean(rows)}
        onClose={() => setRows(null)}
        title="Google акаунти на кампанията"
        created={rows ?? []}
      />
    </>
  );
};

export default GoogleUsersListButton;
